module.exports = __webpack_public_path__ + "static/media/Store.5899457f.png";